export default {
    darkgrey: "#333",
    darkgreyHover: "#222",
    orange: "#ff8504",
    green: "rgb(11, 116, 60)",
    blue: "#0773B9",
    red: "#f73f3f"
}